import classNames from "classnames";
import type { CSSProperties } from "react";

import styles from "./SearchableInput.module.scss";

export interface SearchableOption {
  label: string;
  value: string;
}

interface SearchableInputProps {
  id: string;
  value: string;
  options: Array<SearchableOption | string>;
  placeholder?: string;
  readonly?: boolean;
  outline?: string;
  textStyle?: CSSProperties;
  onChange: (value: string) => void;
}

export function SearchableInput({
  id,
  value,
  options,
  placeholder,
  readonly,
  textStyle,
  onChange,
}: SearchableInputProps) {
  const inlineStyle: CSSProperties = {
    ...textStyle,
  };

  const normalizedOptions: SearchableOption[] = options.map(opt =>
    typeof opt === "string" ? { label: opt, value: opt } : opt,
  );

  const listId = `${id}-datalist`;

  return (
    <>
      <input
        id={id}
        className={classNames(styles.input, readonly && styles.readonly)}
        style={inlineStyle}
        type="text"
        list={listId}
        value={value}
        placeholder={placeholder}
        readOnly={readonly}
        onChange={e => onChange(e.target.value)}
        onBlur={e => {
          if (!e.target.value) return;
          const match = normalizedOptions.find(
            opt => opt.value === e.target.value,
          );
          if (!match) {
            onChange("");
          }
        }}
      />
      <datalist id={listId}>
        {normalizedOptions.map(opt => (
          <option key={`${opt.value}-${opt.label}`} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </datalist>
    </>
  );
}
